import { Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { RouteProps } from 'react-router';

export const Footer: FunctionComponent<RouteProps> = () => (
  <Typography
    sx={{
      color: '#8A8A8A',
      left: '10vw',
      bottom: 0,
      marginTop: 3,
      marginBottom: 5,
    }}
    fontSize="14px"
  >
    © 2022 Innovation Refunds. All rights reserved.
  </Typography>
);
